export default __webpack_public_path__ + "static/media/hubungi_kami_white.4a348e03.svg";